/* eslint-disable no-lonely-if */
import { MUTATION_TYPE, ACTION_TYPE, GETTER_TYPE } from './types'
import ContentApi from '@/api/content'

/* eslint-disable no-param-reassign */

export default {
  state: {
    contentType: '', // news, event, partner, class, course
    content: {},
    // all content
    partners: [], // вузы-партнеры Газпрома
    classes: [], // Газпром-классы
    fields: [], // Месторождения
    events: [],
    news: [],
    courses: [],
    sims: [],
    countOfWaitingContent: 0,
    orgsForEvent: [],
    fileNames: {}
  },

  mutations: {
    // single content info page
    [MUTATION_TYPE.setOrgsForEvent]: (state, orgsForEvent) => {
      state.orgsForEvent = orgsForEvent
    },
    [MUTATION_TYPE.setContentType]: (state, contentType) => {
      if (
        ['news', 'event', 'partner', 'class', 'course', 'training'].includes(
          contentType,
        )
      ) {
        state.contentType = contentType
      }
    },
    [MUTATION_TYPE.setContentData]: (state, data) => {
      state.content = { ...data }
    },
    [MUTATION_TYPE.clearContent]: (state) => {
      state.content = {}
      state.contentType = ''
    },
    // all content
    [MUTATION_TYPE.setAllPartners]: (state, partners) => {
      state.partners = partners
    },
    [MUTATION_TYPE.setContent]: (state, content) => {
      state.news = content.filter((p) => p.type === 'Новость')
      state.events = content.filter((p) => p.type === 'Мероприятие')
      state.partners = content.filter(
        (p) => p.type === 'ВУЗ-партнер' || p.type === 'СПО',
      )
      state.classes = content.filter((p) => p.type === 'ГП-класс')
      state.courses = content.filter((p) => p.type === 'Курс')
      state.sims = content.filter((p) => p.type === 'Тренажер')
    },
    [MUTATION_TYPE.pushContent]: (state, content) => {
      state.news = state.news.concat(
        content.filter((p) => p.type === 'Новость'),
      )
      state.events = state.events.concat(
        content.filter((p) => p.type === 'Мероприятие'),
      )
      state.partners = state.partners.concat(
        content.filter((p) => p.type === 'ВУЗ-партнер' || p.type === 'СПО'),
      )
      state.classes = state.classes.concat(
        content.filter((p) => p.type === 'ГП-класс'),
      )
      state.courses = state.courses.concat(
        content.filter((p) => p.type === 'Курс'),
      )
      state.sims = state.sims.concat(
        content.filter((p) => p.type === 'Тренажер'),
      )
    },
    [MUTATION_TYPE.setEvents]: (state, events) => {
      state.events = events
    },
    [MUTATION_TYPE.setCountOfWaitingContent]: (
      state,
      countOfWaitingContent,
    ) => {
      state.countOfWaitingContent = countOfWaitingContent
    },
    [MUTATION_TYPE.setNews]: (state, news) => {
      state.news = news
    },
    [MUTATION_TYPE.pushEvents]: (state, events) => {
      state.events = state.events.concat(events)
    },
    [MUTATION_TYPE.pushNews]: (state, news) => {
      state.news = state.news.concat(news)
    },
    [MUTATION_TYPE.setGPClasses]: (state, classes) => {
      state.classes = classes
    },
    [MUTATION_TYPE.setGPFields]: (state, fields) => {
      state.fields = fields
    },
    [MUTATION_TYPE.updateTitle]: (state, title) => {
      state.content.contentObject.title = title
    },
    [MUTATION_TYPE.updateEventSettings]: (state, voting) => {
      if (state.content.contentObject.votingSettings) {
        state.content.contentObject.votingSettings.participant = voting
      } else {
        state.content.contentObject.votingSettings = {
          participant: voting,
          choice: null
        }
      }
    },
    [MUTATION_TYPE.updateEventVoting]: (state, voting) => {
      state.content.contentObject.votingSettings = {
        participant: state.content.contentObject.votingSettings
          ? state.content.contentObject.votingSettings.participant
          : null,
        choice: voting
      }
    },
    [MUTATION_TYPE.updateShortDescription]: (state, shortDescription) => {
      state.content.contentObject.shortDescription = shortDescription
    },
    [MUTATION_TYPE.updateFullDescription]: (state, fullDescription) => {
      state.content.contentObject.fullDescription = fullDescription
    },
    [MUTATION_TYPE.updateDate]: (state, date) => {
      state.content.contentObject.scheduleDate = date
    },
    [MUTATION_TYPE.updateImages]: (state, image) => {
      state.content.images.push(image)
    },
    [MUTATION_TYPE.updateVideos]: (state, video) => {
      state.content.videos.push(video)
    },
    [MUTATION_TYPE.addFiles]: (state, files) => {
      files.forEach((el) => state.content.contentObject.files.push(el))
    },
    [MUTATION_TYPE.deleteFile]: (state, fileId) => {
      state.content.contentObject.files = state.content.contentObject.files.filter(
        (el) => el.id !== fileId,
      )
    },
    [MUTATION_TYPE.deleteAvatar]: (state) => {
      state.content.contentObject.avatar = null
    },
    [MUTATION_TYPE.addLinkToDescription]: (state, file) => {
      if (!state.content.contentObject.fullDescription) {
        state.content.contentObject.fullDescription = ''
      }
      state.content.contentObject.fullDescription += `<p><a href="/api/files/${
        file.physicalName
      }">${file.name}</a></p>`
    },
    [MUTATION_TYPE.setVideoPreview]: (state, payload) => {
      state.content.contentObject.files.find(
        (el) => el.id === payload.videoId,
      ).description = payload.description
    },
    [MUTATION_TYPE.setAvatar]: (state, avatarId) => {
      state.content.contentObject.avatar = state.content.contentObject.files.filter(
        (el) => el.id === avatarId,
      )[0].id
    },
    [MUTATION_TYPE.setAvatarWithoutFiles]: (state, file) => {
      state.content.contentObject.avatar = file.id
      state.content.contentObject.avatarFile = file
    },
    [MUTATION_TYPE.addFileName]: (state, file) => {
      state.fileNames[file.base] = file.name
    },
    [MUTATION_TYPE.resetFileNames]: (state) => {
      state.fileNames = {}
    },
    [MUTATION_TYPE.updateRating]: (state, rating) => {
      if (rating === 'like') {
        if (state.content.contentObject.userLike) {
          state.content.contentObject.likes -= 1
          state.content.contentObject.userLike = null
        } else if (state.content.contentObject.userLike === false) {
          state.content.contentObject.likes += 1
          state.content.contentObject.dislikes -= 1
          state.content.contentObject.userLike = true
        } else {
          state.content.contentObject.likes += 1
          state.content.contentObject.userLike = true
        }
      } else {
        if (state.content.contentObject.userLike) {
          state.content.contentObject.dislikes += 1
          state.content.contentObject.likes -= 1
          state.content.contentObject.userLike = false
        } else if (state.content.contentObject.userLike === false) {
          state.content.contentObject.dislikes -= 1
          state.content.contentObject.userLike = null
        } else {
          state.content.contentObject.dislikes += 1
          state.content.contentObject.userLike = false
        }
      }
    }
  },

  actions: {
    // all content
    [ACTION_TYPE.fetchAllContent]: ({ commit }, pages) => new Promise((resolve) => {
      if (!pages.filters.filter((p) => p.param === 'type')) {
        pages.filters.push({
          param: 'type',
          needle: [
            'Новость',
            'Мероприятие',
            'ГП-класс',
            'ВУЗ-партнер',
            'СПО',
            'Курс',
            'Тренажер'
          ],
          isStrict: false
        })
      }
      ContentApi.getContent(
        pages.perPage,
        pages.pageNumber,
        pages.filters,
        pages.sorting,
      ).then((response) => {
        if (pages.filters.filter((p) => p.needle[0] === 'ожидает').length) {
          commit(
            'setCountOfWaitingContent',
            response.data.contentObjects.total,
          )
        }
        if (pages.pageNumber === 1) {
          commit('setContent', response.data.contentObjects.docs)
        } else if (
          response.data.contentObjects.total
            > pages.perPage * (pages.pageNumber - 1)
        ) {
          commit('pushContent', response.data.contentObjects.docs)
        }
        resolve()
      })
    }),
    [ACTION_TYPE.fetchCountOfWaitingContent]: ({ commit }) => new Promise((resolve) => {
      ContentApi.getVerificationCount().then((response) => {
        commit('setCountOfWaitingContent', response.data.contentObjectsCount)
        resolve()
      })
    }),
    [ACTION_TYPE.fetchAllPartnersForMap]: ({ commit }, filters) => new Promise((resolve) => {
      ContentApi.getAllPartners(filters).then((response) => {
        commit('setAllPartners', response.data)
        resolve()
      })
    }),
    [ACTION_TYPE.fetchAllPartners]: ({ commit }, filters) => new Promise((resolve) => {
      filters.push({
        param: 'type',
        needle: ['ВУЗ-партнер', 'СПО'],
        isStrict: false
      })
      ContentApi.getContent(1000, 1, filters).then((response) => {
        commit('setAllPartners', response.data.contentObjects.docs)
        resolve()
      })
    }),
    [ACTION_TYPE.fetchEvents]:
      ({ commit }, { pages, withoutClassEvents }) => new Promise((resolve) => {
        pages.filters.push({
          param: 'type',
          needle: ['Мероприятие'],
          isStrict: false
        })
        ContentApi.getContent(pages.perPage, pages.pageNumber, pages.filters, [
          ['scheduleDate', 'DESC']
        ], withoutClassEvents).then((response) => {
          if (pages.pageNumber === 1) {
            commit('setEvents', response.data.contentObjects.docs)
          } else if (
            response.data.contentObjects.total
            > pages.perPage * (pages.pageNumber - 1)
          ) {
            commit('pushEvents', response.data.contentObjects.docs)
          }
          resolve(response.data.contentObjects.total)
        })
      }),
    [ACTION_TYPE.fetchNews]: ({ commit }, pages) => new Promise((resolve) => {
      pages.filters.push({
        param: 'type',
        needle: ['Новость'],
        isStrict: false
      })
      ContentApi.getContent(pages.perPage, pages.pageNumber, pages.filters, [
        ['createdAt', 'DESC']
      ]).then((response) => {
        if (pages.pageNumber === 1) {
          commit('setNews', response.data.contentObjects.docs)
        } else if (
          response.data.contentObjects.total
            > pages.perPage * (pages.pageNumber - 1)
        ) {
          commit('pushNews', response.data.contentObjects.docs)
        }
        resolve(response.data.contentObjects.total)
      })
    }),
    [ACTION_TYPE.fetchGPClassesForMap]: ({ commit }, filters) => new Promise((resolve) => {
      ContentApi.getAllClasses(filters).then((response) => {
        commit('setGPClasses', response.data)
        resolve()
      })
    }),
    [ACTION_TYPE.fetchGPFields]: ({ commit }) => new Promise((resolve) => {
      ContentApi.getAllFields().then((response) => {
        commit('setGPFields', response.data)
        resolve()
      })
    }),
    [ACTION_TYPE.fetchGPClasses]: ({ commit }, filters) => new Promise((resolve) => {
      filters.push({ param: 'type', needle: ['ГП-класс'], isStrict: false })
      ContentApi.getContent(1000, 1, filters).then((response) => {
        commit('setGPClasses', response.data.contentObjects.docs)
        resolve()
      })
    }),
    [ACTION_TYPE.fetchSelectedClass]: ({ commit }, id) => new Promise((resolve) => {
      ContentApi.getSelectedClass(id)
        .then((response) => {
          commit('setContentData', response.data)
          if (response.data === null) {
            resolve('null')
          } else {
            resolve()
          }
        })
        .catch((error) => {
          resolve(error)
        })
    }),
    [ACTION_TYPE.fetchUserClass]: ({ commit }, id) => new Promise((resolve) => {
      ContentApi.getUserClass(id)
        .then((response) => {
          commit('setContentData', response.data)
          if (response.data === null) {
            resolve('null')
          } else {
            resolve()
          }
        })
        .catch((error) => {
          resolve(error)
        })
    }),
    [ACTION_TYPE.fetchSelectedPartner]: ({ commit }, id) => new Promise((resolve) => {
      ContentApi.getSelectedPartner(id)
        .then((response) => {
          commit('setContentData', response.data)
          if (response.data === null) {
            resolve('null')
          } else {
            resolve()
          }
        })
        .catch((error) => {
          resolve(error)
        })
    }),
    [ACTION_TYPE.fetchSelectedContent]: async (context, id) => {
      try {
        const response = await ContentApi.getSelectedContent(id)
        context.commit('setContentData', response.data)
      } catch (error) {
        return error
      }
    },
    [ACTION_TYPE.addNewFiles]: ({ commit }, files) => {
      commit('addFiles', files)
    },
    [ACTION_TYPE.addNewLoadedFiles]: ({ commit }, payload) => {
      if (!payload.type) {
        payload.files.forEach((el) => commit('addLinkToDescription', el))
      } else if (payload.type === 'img' || payload.type === 'video') {
        commit('addFiles', payload.files)
      }
    },
    [ACTION_TYPE.addLink]: ({ commit }, file) => {
      commit('addLinkToDescription', file)
    },
    [ACTION_TYPE.saveContent]: async ({ commit }, content) => {
      const response = await ContentApi.sendSavedContent(content)
      commit('setContentData', response.data)
      return response.data.contentObject.id
    },
    [ACTION_TYPE.saveContentByTeacher]: async ({ commit }, content) => {
      const response = await ContentApi.sendSavedContentByTeacher(content)
      commit('setContentData', response.data)
      return response.data.contentObject.id
    },
    [ACTION_TYPE.addContent]: (context, type) => new Promise((resolve, reject) => {
      ContentApi.addContent(type)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    }),
    [ACTION_TYPE.addContentByTeacher]: (context, type) => new Promise((resolve, reject) => {
      ContentApi.addContentByTeacher(type)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    }),
    [ACTION_TYPE.deleteContent]: (context, id) => new Promise((resolve, reject) => {
      ContentApi.deleteContent(id)
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    }),
    [ACTION_TYPE.sendContentToVerification]:
      ({ commit }, payload) => new Promise((resolve, reject) => {
        ContentApi.sendContentToVerification(
          payload.id,
          payload.text,
          payload.file,
        )
          .then((response) => {
            commit('setContentData', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      }),
    [ACTION_TYPE.fetchOrgsForEvent]: ({ commit }, payload) => new Promise((resolve, reject) => {
      ContentApi.getOrgsForEvent(payload.id)
        .then((response) => {
          commit('setOrgsForEvent', response.data)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    }),
    [ACTION_TYPE.fetchMemberStatus]: (context, payload) => new Promise((resolve, reject) => {
      ContentApi.isMembers(payload.ids, payload.eventId)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    }),
    [ACTION_TYPE.updateMemberStatus]: (context, payload) => new Promise((resolve, reject) => {
      ContentApi.updateMemberStatus(payload.users, payload.eventId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    }),
    [ACTION_TYPE.sendResultOfVerification]: async (context, payload) => {
      await ContentApi.sendResultOfVerification(
        payload.id,
        payload.status,
        payload.text,
      )
    },
    [ACTION_TYPE.changeVideoPreview]: ({ commit, state }, payload) => {
      if (
        state.content.contentObject.files.filter((el) => el.id === payload.videoId)
          .length
      ) {
        commit('setVideoPreview', payload)
      }
    },
    [ACTION_TYPE.changeAvatar]: ({ commit, state }, file) => {
      if (
        state.content.contentObject.files.filter((el) => el.id === file.id)
          .length < 1
      ) {
        const newFile = {
          id: file.id,
          description: file.description,
          name: file.name,
          physicalName: file.physicalName,
          type: file.type
        }
        commit('addFiles', [newFile])
      }
      commit('setAvatar', file.id)
    },
    [ACTION_TYPE.deleteAvatar]: ({ commit }) => {
      commit('deleteAvatar')
    }
  },

  getters: {
    // single content info page
    [GETTER_TYPE.getContent]: (state) => state.content,
    [GETTER_TYPE.getContentType]: (state) => state.contentType,
    [GETTER_TYPE.getTitlePrefix]: (state) => {
      switch (state.contentType) {
        case 'news':
          return 'Новости'
        case 'event':
          return 'Мероприятия'
        case 'partner':
          return 'Вузы-партнеры и учреждения СПО ПАО "Газпром"'
        case 'class':
          return 'Классы ПАО "Газпром"'
        case 'course':
          return 'Курсы'
        default:
          return ''
      }
    },
    // all content
    [GETTER_TYPE.getAllPartners]: (state) => state.partners,
    [GETTER_TYPE.getEvents]: (state) => state.events,
    [GETTER_TYPE.getNews]: (state) => state.news,
    [GETTER_TYPE.getCourses]: (state) => state.courses,
    [GETTER_TYPE.getSims]: (state) => state.sims,
    [GETTER_TYPE.getGPClasses]: (state) => state.classes,
    [GETTER_TYPE.getGPFields]: (state) => state.fields,
    [GETTER_TYPE.getOrgsForEvent]: (state) => state.orgsForEvent,
    [GETTER_TYPE.getCountOfWaitingContent]: (state) => state.countOfWaitingContent,
    [GETTER_TYPE.getFileNames]: (state) => state.fileNames
  }
}
